export default __webpack_public_path__ + "8e81fa0ff12c53915beadc7f623498d6.wav";